import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import MaterialProductionPopup from './MaterialProductionTable';
import PendingWoData from './PendingWoData';
import { decryptAES } from '../../../utils/Encryption';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import moment from 'moment';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import TransactionStockServices from '../../../services/axiosServices/apiServices/TransactionStockServices';
import { de, is, th } from 'date-fns/locale';
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import { SelectItemListPopUp } from '../../../components/dropdown/SelectItemListPopUp';
import { permission } from '../../../utils/enums/ValidationMessage';

export default class MaterialProduction extends Component {
    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.SwalServices = new SwalServices();
        //this.otherFormsServices = new this.OtherFormsServices();
        this.transactionStockServices = new TransactionStockServices();
        this.masterEntryServices = new MasterEntryServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            globalUserID: '',
            usp_Users: [],
            isSelectItemPopUp: false,
            isSelectNumberPopUp: false,
            isSelectNumberPopUpForThroughtWO: false,
            isSelectItemObjectItemPopUp: false,
            isModalOpen: false,
            isSaving: false,
            isPendingOpen: false,
            isModalOpenForEditItem: false,
            isTable2Expanded: false,
            isShown: false,
            rowData: [],
            colDefs: [],
            pendingRowData: [],
            invoiceRowData: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            table2Data: [],
            table2ColDefs: [],
            firstList: [],
            secondList: [],
            tempSecondList: [],
            open: false,
            itemRowData: [],
            productionObject: {
                idMaterialProduction: 0,
                updateStatus: 0,
                prefix: '',
                productionNo: '',
                originalPentQty: 0,
                date: moment(new Date().toISOString()).format('YYYY-MM-DD'),
                authEmpList: [],
                idAuthEmp: 0,
                plantList: [],
                idPlant: 0,
                typeList: [
                    { value: 1, label: 'Through Planning' },
                    { value: 2, label: 'Through W.O.' },
                ],
                idType: 1,
                productList: [],
                idProduct: 0,
                productName: '',
                numberList: [],
                idNumber: 0,
                quantity: '',
                prodQty: '',
                pentQty: '',
                pendingqty: '',
                dtMaterial: [],
                e_Date: '',
                dbQty: 0,
                woRecvNo: ''
            },
            itemObject: {
                keyId: 0,
                drawingNo: '',
                itemTypeList: [
                    { value: 1, label: 'RAW MATERIAL' },
                    { value: 2, label: 'FINISHED GOODS' },
                    { value: 3, label: 'SEMI FINISHED' },
                    { value: 4, label: 'SCRAP MATERIAL' },
                ],
                idItemType: 2,
                itemType: '',
                itemList: [],
                itemName: '',
                idItem: 0,
                quantity: '',
                weight: '',
                itemRemarks: '',
                bom: 0,
                currentStock: 0,
                status: 0,
            },
            selectItemColDefs: [
                {
                    field: "drawingNo",
                    headerName: "Drawing No",
                    minWidth: window.innerWidth * 0.07,
                    flex: 0.5,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "itemType",
                    headerName: "Item Type",
                    minWidth: window.innerWidth * 0.1,
                    flex: 1,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "itemName",
                    headerName: "Item Name",
                    minWidth: window.innerWidth * 0.1,
                    flex: 1,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "pendingQty",
                    headerName: "Pending Quantity",
                    minWidth: window.innerWidth * 0.1,
                    flex: 1,
                    filter: true,
                    floatingFilter: true,
                },
            ],
            selectNumberColDefs: [
                {
                    field: "workOrderNo",
                    headerName: "Work Order No",
                    minWidth: window.innerWidth * 0.07,
                    flex: 0.5,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "planningNo",
                    headerName: "Planning No",
                    minWidth: window.innerWidth * 0.1,
                    flex: 1,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "date",
                    headerName: "Date",
                    minWidth: window.innerWidth * 0.1,
                    flex: 1,
                    filter: true,
                    floatingFilter: true,
                },
            ],
            selectNumberColDefsForThroughWO: [
                {
                    field: "woRecvNo",
                    headerName: "Wo Recv No",
                    minWidth: window.innerWidth * 0.07,
                    flex: 0.5,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "woRecvDate",
                    headerName: "Wo Recv Date",
                    minWidth: window.innerWidth * 0.1,
                    flex: 1,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "customer",
                    headerName: "Customer",
                    minWidth: window.innerWidth * 0.1,
                    flex: 1,
                    filter: true,
                    floatingFilter: true,
                },
            ],
            selectItemColDefsForITems: [
                {
                    field: "itemCategory",
                    headerName: "Item Category",
                    minWidth: window.innerWidth * 0.06,
                    flex: 0.6,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "itemCategoryDesc",
                    headerName: "Item Category Desc",
                    minWidth: window.innerWidth * 0.06,
                    flex: 0.6,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "searchText",
                    headerName: "Search Text",
                    minWidth: window.innerWidth * 0.05,
                    flex: 0.5,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "drawingNo",
                    headerName: "Drawing No",
                    minWidth: window.innerWidth * 0.08,
                    flex: 0.8,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "itemName",
                    headerName: "Item Name",
                    minWidth: window.innerWidth * 0.15,
                    flex: 1.5,
                    filter: true,
                    floatingFilter: true,
                },
            ],
            validState: {
                isValid: true,
                error: {},
            },
            validationRulesForProduction: {
                idAuthEmp: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "auth employee"
                        ),
                    },
                ],
                idPlant: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "plant"
                        ),
                    },
                ],
                idType: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "type"
                        ),
                    },
                ],
                idProduct: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "product"
                        ),
                    },
                ],
                idNumber: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "number"
                        ),
                    },
                ],
            },
            validationRulesForItem: {
                idItemType: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "type"
                        ),
                    },
                ],
                idItemName: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "item"
                        ),
                    },
                ],
                idType: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "type"
                        ),
                    },
                ],
                quantity: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "quantity"
                        ),
                    },
                ],
            },
        }
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };
    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.resetProductObject();
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState,
            isModalOpen: true,
        }, () => {
            this.usp_Transaction_MaterialProductionSelectbyId(event.data.idMaterialProduction);
        });
    };

    resetDetailsFields = () => {
        let data = this.state.productionObject;
        data.idMaterialProduction = 0;
        data.updateStatus = 0;
        data.prefix = '';
        data.productionNo = '';
        data.date = moment(new Date().toISOString()).format('YYYY-MM-DD');
        //data.authEmpList: [],
        data.idAuthEmp = 0;
        //data.plantList: [],
        data.idPlant = 0;
        data.originalPentQty = null;
        // data.typeList: [
        //     { value: 1, label: 'Through Planning' },
        //     { value: 2, label: 'Through W.O.' },
        // ],
        data.idType = 1;
        data.productList = [];
        data.idProduct = 0;
        // data.numberList = [];
        data.productName = '';
        data.woRecvNo = '';
        data.idNumber = 0;
        data.quantity = '';
        data.prodQty = '';
        data.pentQty = '';
        data.pendingqty = '';
        data.dtMaterial = [];
        data.e_Date = '';
        data.dbQty = 0;

        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            productionObject: data, itemRowData: [],
            validState: validState
        });
    }

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.resetDetailsFields();
        this.resetProductObject();
        this.setState({ isModalOpen: true, open: false }, () => {
            this.loadInitialData();
            this.getPrefixSelectPrefix();
        });
    };

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };

    setPendingModel = () => {
        // this.setState({ isPendingOpen: !this.state.isPendingOpen }, () => {
        if (this.state.isPendingOpen === false) {
            this.addPendingData()
        }
        else {
            this.setState({ isPendingOpen: !this.state.isPendingOpen });
        }
        // });
    };

    closePopup = () => {
        this.setState({ isModalOpen: false, });
    };

    back = () => {
        this.setState({ open: !this.state.open });
    }

    handleChange = (event, name, field) => {
        if (field === "production") {
            let value = event.target.value.toUpperCase();
            let details = this.state.productionObject;
            details[name] = value;
            this.setState({ productionObject: details }, () => {
                if (name === 'prodQty') {
                    let details = this.state.productionObject;
                    const prodQty = Number(value) || 0;
                    const originalPentQty = Number(details.originalPentQty || details.pentQty || 0);

                    if (originalPentQty > 0) {
                        if (!details.originalPentQty) {
                            details.originalPentQty = originalPentQty;
                        }

                        details.prodQty = prodQty;
                        details.pentQty = originalPentQty - prodQty;
                    }
                }

                this.setState({ productionObject: details });
            });
        }
        else if (field === "item") {
            let value = event.target.value.toUpperCase();
            let details = this.state.itemObject;
            details[name] = value;
            this.setState({ itemObject: details });
        }
    }
    handleChangeForDropdown = (event, name, field) => {
        if (field === "production") {
            let details = this.state.productionObject;
            let value = event.value;
            details[name] = value;
            this.setState({ productionObject: details }, () => {
                if (name === "idType") {
                    this.cmbFrom_SelectedIndexChanged();
                } else if (name === "idNumber") {
                    this.cmbWO_EditValueChanged();
                } else if (name === "idProduct") {
                    this.cmbProduct_EditValueChanged();
                }
            });
        }
        else if (field === "item") {
            let details = this.state.itemObject;
            let value = event.value;
            details[name] = value;
            this.setState({ itemObject: details }, () => {
                if (name === "idItemType") {
                    this.getMaster_ItemSelectbyItemType(event.label);
                } else if (name === "idItem") {
                    this.getItemMasterSelectbyID();
                }
            });
        }
    }

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };


    componentDidMount = () => {
        // let params = new URLSearchParams(window.location.search);
        // let id = params.get("id")
        // if (id) {
        //     let urlId = decryptAES(id)
        //     if (urlId) {
        //         if (urlId != null) {
        //             this.setState({ urlId: urlId });
        //         }
        //     }
        // }

        let prop = getAuthProps()
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser ? prop.idUser : 0, entryBy: prop.name, companyName: prop.companyName, globalUserID: prop.globalUserID }, () => {
                this.procSelectAllRecordsSP();
                this.loadInitialData();
                this.usp_GetAllUsers();
            });
        }
    }

    usp_GetAllUsers = () => {
        this.accountTransactionServices.usp_GetAllUsers().then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                if (data.length > 0) {
                    this.setState({
                        usp_Users: data,
                    });
                }
            }
        });
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Material Production",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            width: this.getPinnedColumnWidth(key) !== undefined ? this.getPinnedColumnWidth(key) : window.innerWidth * 0.05,
                            //pinned: ["sR.No", "jobWorkNo", "jobWorkInwardDate", "jobWorkFrom", "invoiceNo"].includes(key) ? "left" : undefined,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idMaterialProduction", "sR.No"].includes(key) ? true : false,
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.toLowerCase().includes("date") ? (params) => {
                                if (!params.value) return "";
                                const date = new Date(params.value);
                                return moment(date).format('DD-MM-YYYY')
                            } : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "Material Production",
                            colName: colName
                        }, () => {
                            this.setPermissions(permissions);
                            this.procSelectAllRecord2GridviewSP(id);
                            this.getPrefixSelectPrefix();
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                        this.getPrefixSelectPrefix();
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    getColumnWidth = (key) => {
        const colwidth = {
            "productionNo": window.innerWidth * 0.05,
            "productionDate": window.innerWidth * 0.07,
            "planningNo": window.innerWidth * 0.05,
            "workOrderNo": window.innerWidth * 0.05,
            "itemName": window.innerWidth * 0.18,
            "plantDetails": window.innerWidth * 0.06,
            "productionQuantity": window.innerWidth * 0.06,
            "issueStatus": window.innerWidth * 0.06,
            "issueNo": window.innerWidth * 0.05,
            "status": window.innerWidth * 0.08,
        }
        return colwidth[key]
    }
    getPinnedColumnWidth = (key) => {
        const colwidth = {
            // "sR.No": window.innerWidth * 0.05,
            // "jobWorkNo": window.innerWidth * 0.09,
            // "jobWorkInwardDate": window.innerWidth * 0.08,
            // "jobWorkFrom": window.innerWidth * 0.08,
            // "invoiceNo": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }

    procSelectAllRecord2GridviewSP = (id) => {
        let request = {
            id: id,
            formname: "Material Production",
            allowToRateVisible: 1,
        }
        if (id > 0) {
            this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    const dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth2(key) !== undefined ? this.getColumnWidth2(key) : window.innerWidth * 0.06,
                            filter: true,
                            floatingFilter: true,
                            flex: 1,
                        }));
                        this.setState({
                            table2Data: dynamicData,
                            table2ColDefs: dynamicColDefs,
                            isTable2Expanded: true
                        });
                    }
                }
            });
        }
    }

    getColumnWidth2 = (key) => {
        const colwidth = {
            "drawingNo": window.innerWidth * 0.07,
            "itemCategory": window.innerWidth * 0.16,
            "itemName": window.innerWidth * 0.3,
            "quantity": window.innerWidth * 0.05,
            "rate": window.innerWidth * 0.05,
        }
        return colwidth[key]
    }

    loadInitialData = async () => {

        // Example API call for initial grid data
        //let response = await this.transactionStockServices.getMaterialProductionData();
        // if (response.statusCode === 200) {
        //     this.setState({ rowData: response.data });
        // } else {
        //     this.SwalServices.error("Failed to load data");
        // }

        //Example: Load dropdown lists
        //let authEmpList = await this.otherFormsServices.getAuthEmployeeList();
        let plantList = await this.transactionStockServices.usp_Master_PlantSelect(this.state.idCompany);
        //let typeList = await //this.transactionStockServices.getTypeList();
        //let productList = await this.transactionStockServices.getProductList();
        //let numberList = await this.transactionStockServices.getNumberList();


        let productionObject = this.state.productionObject;
        productionObject.plantList = plantList?.responseItem?.responseContent ? plantList?.responseItem?.responseContent : [];
        //productionObject.typeList = typeList;
        //productionObject.productList = productList;
        //productionObject.numberList = numberList;
        productionObject.plantList.map((item) => {
            item.label = item.plantDetails;
            item.value = item.idPlant;
            return item;
        });
        productionObject.idPlant = productionObject.plantList[0].idPlant
        this.setState({ productionObject: productionObject }, () => {
            this.cmbFrom_SelectedIndexChanged()
            this.getMaster_ItemSelectbyItemType('FINISHED GOODS');
        });
        // this.setState(prevState => ({
        //     productionObject: {
        //         ...prevState.productionObject,
        //         //authEmpList,
        //         plantList,
        //         typeList,
        //         productList,
        //         numberList
        //     }
        // }));
    }

    getMaster_ItemSelectbyItemType = (label) => {
        let request = [label, this.state.idCompany];
        this.masterEntryServices.getMaster_ItemSelectbyItemType(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                let itemObject = this.state.itemObject;
                // itemObject.itemList = data;
                // itemObject.idItem = itemObject.idItem > 0 ? itemObject.idItem : '';

                // data = data.map((x) => ({
                //     value: x.idItem,
                //     label: x.itemCategory + ' - ' + x.itemName + ' - ' + x.drawingNo + ' - ' + x.searchText,
                //     itemName: x.itemName,
                // }));

                // if (name === 'itemTypeId2') {
                //     itemObject.itemList2 = data;
                //     itemObject.itemId2 = "";
                // } else if (name === 'itemTypeId') {
                itemObject.itemList = data;
                itemObject.idItem = itemObject.idItem > 0 ? itemObject.idItem : 0;
                ///}
                this.setState({
                    itemObject: itemObject,
                });
            }
        });
    }

    getPrefixSelectPrefix = () => {
        let request = {
            formname: "FrmTransactionMaterialProduction",
            idCompany: this.state.idCompany,
            idCompanyDivision: 0,
        };
        this.accountTransactionServices.getPrefixSelectPrefix(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent[0];
                let dt = this.state.productionObject;
                if (data) {
                    dt.prefix = data.prefix;
                }
                this.setState({ productionObject: dt }, () => {
                    this.getInwardNoCount();
                });
            } else {
                this.getInwardNoCount();
            }
        });
    }

    getInwardNoCount = () => {
        // this.accountTransactionServices.getInwardNoCount(request).then((response) => {
        //     if (response.statusCode == 200 && response.responseItem !== null) {
        //         let data = response.responseItem.responseContent;
        //debugger;
        let details = this.state.productionObject;
        let maxIdPaymentMake = this.state.rowData.length > 0
            ? Math.max(...this.state.rowData.map(item => item.idMaterialProduction))
            : 0;
        let inwardNo = String(maxIdPaymentMake + 1).padStart(3, '0');
        details.productionNo = details.prefix + inwardNo;
        this.setState({ productionObject: details }, () => {
            //this.getNetworkConfiguration();
        })
        //     }
        // });
    }

    cmbFrom_SelectedIndexChanged = () => {
        if (this.state.productionObject.idType === 2) { //"Through W.O.") {
            this.BindWorkOrder();
        } else if (this.state.productionObject.idType === 1) {
            this.BindPlanningData();
        }
    };

    // ---------------------- BindWorkOrder ----------------------
    BindWorkOrder = async () => {
        const params = [
            this.state.idCompany,
            this.state.productionObject.updateStatus || 0,
            this.state.productionObject.idMaterialProduction || 0
        ];
        const response = await this.transactionStockServices
            .usp_Transaction_WorkOrderRecvSelect_NotInMaterialProduction(params);

        if (response.statusCode === 200 && response.responseItem) {
            let data = response.responseItem.responseContent;
            data = data.map((item) => ({
                ...item,
                woRecvDate: moment(item.woRecvDate).format('DD-MMM-YYYY'),
            }));
            let productionObject = this.state.productionObject;
            productionObject.numberList = data;
            productionObject.woRecvNo = productionObject.idNumber;
            this.setState({ productionObject: productionObject });
        }
        // else {
        //     this.SwalServices.error("No Work Orders Found");
        // }
    };

    // ---------------------- BindPlanningData ----------------------
    BindPlanningData = async () => {
        const params = [
            this.state.idCompany,
            this.state.productionObject.updateStatus || 0,
            this.state.productionObject.idMaterialProduction || 0
        ];

        const response = await this.transactionStockServices
            .usp_Transaction_WorkPlanningSelectNotinMaterialProduction(params);

        if (response.statusCode === 200 && response.responseItem) {
            let data = response.responseItem.responseContent;
            data = data.map((item) => ({
                ...item,
                date: moment(item.date).format('DD-MMM-YYYY'),
            }));
            let productionObject = this.state.productionObject;
            productionObject.numberList = data;
            productionObject.idNumber = productionObject.idNumber;
            this.setState({ productionObject: productionObject });
        }
        // else {
        //     this.SwalServices.error("No Planning Records Found");
        // }
    };

    cmbWO_EditValueChanged = () => {
        if (this.state.productionObject.idType === 2) { //"Through W.O.") {
            this.usp_Transaction_WorkOrderRecvSelectbyId_ForMaterialProduction();
        } else if (this.state.productionObject.idType === 1) {
            this.usp_Transaction_WorkPlannigSelectbyId_ForMaterialProduction();
        }
    };

    usp_Transaction_WorkPlannigSelectbyId_ForMaterialProduction = async () => {
        const params = [
            this.state.productionObject.idNumber,
            this.state.idCompany,
            this.state.productionObject.idPlant || 0,
            this.state.productionObject.idMaterialProduction || 0,
            this.state.productionObject.updateStatus || 0,
        ];
        const response = await this.transactionStockServices
            .usp_Transaction_WorkPlannigSelectbyId_ForMaterialProduction(params);

        if (response.statusCode === 200 && response.responseItem) {
            let data = response.responseItem.responseContent;
            // data = data.map((item) => ({
            //     value: item.idWorkPlanningItems, // Adjust based on actual field names
            //     label: item.drawingNo + ' - ' + item.itemType + ' - ' + item.itemName,
            //     name: item.itemName,
            // }));
            let productionObject = this.state.productionObject;
            productionObject.productList = data;
            productionObject.idProduct = productionObject.idProduct;
            this.setState({ productionObject: productionObject });
        }
        // else {
        //     this.SwalServices.error("No Work Orders Found");
        // }
    };

    usp_Transaction_WorkOrderRecvSelectbyId_ForMaterialProduction = async () => {
        const params = [
            this.state.productionObject.idNumber,
            this.state.idCompany,
            this.state.productionObject.idPlant || 0,
            this.state.productionObject.idMaterialProduction || 0,
            this.state.productionObject.updateStatus || 0,
        ];

        const response = await this.transactionStockServices
            .usp_Transaction_WorkOrderRecvSelectbyId_ForMaterialProduction(params);

        if (response.statusCode === 200 && response.responseItem) {
            let data = response.responseItem.responseContent;
            // data = data.map((item) => ({
            //     value: item.idwoOrderRecvItems,
            //     label: item.drawingNo + ' - ' + item.itemType + ' - ' + item.itemName,
            //     name: item.itemName,
            // }));
            let productionObject = this.state.productionObject;
            productionObject.productList = data;
            productionObject.idProduct = productionObject.idProduct;
            this.setState({ productionObject: productionObject });
        }
        // else {
        //     this.SwalServices.error("No Planning Records Found");
        // }
    };

    cmbProduct_EditValueChanged = () => {
        if (this.state.productionObject.idProduct > 0) {
            if (this.state.productionObject.idType === 2) { //"Through W.O.") {
                this.usp_Transaction_WorkOrderRecvItemQuantitySelect_ForMaterialProduction();
            } else if (this.state.productionObject.idType === 1) {
                this.usp_Transaction_WorkPlanningItemQuantitySelect_ForMaterialProduction();
            }
        }
    };

    usp_Transaction_WorkPlanningItemQuantitySelect_ForMaterialProduction = async () => {
        if (this.state.productionObject.idProduct > 0) {
            const response = await this.transactionStockServices
                .usp_Transaction_WorkPlanningItemQuantitySelect_ForMaterialProduction(this.state.productionObject.idProduct);

            if (response.statusCode === 200 && response.responseItem) {
                let data = response.responseItem.responseContent[0];
                let productionObject = this.state.productionObject;

                productionObject.quantity = 0;
                productionObject.prodQty = 0;
                // productionObject.pentQty = 0;
                productionObject.pendingqty = 0;
                if (data) {
                    productionObject.quantity = data.prodPendingQty;
                    //productionObject.prodQty = data.prodPendingQty;
                    productionObject.pentQty = data.prodPendingQty;
                    productionObject.pendingqty = data.prodPendingQty;
                }
                this.setState({ productionObject: productionObject, pendingRowData: response.responseItem.responseContent });
            }
            // else {
            //     this.SwalServices.error("No Work Orders Found");
            // }
        }
    };

    usp_Transaction_WorkOrderRecvItemQuantitySelect_ForMaterialProduction = async () => {
        if (this.state.productionObject.idProduct > 0) {
            const response = await this.transactionStockServices
                .usp_Transaction_WorkOrderRecvItemQuantitySelect_ForMaterialProduction(this.state.productionObject.idProduct);

            if (response.statusCode === 200 && response.responseItem) {
                let data = response.responseItem.responseContent[0];
                let productionObject = this.state.productionObject;

                productionObject.quantity = 0;
                //productionObject.prodQty = 0;
                // productionObject.pentQty = 0;
                productionObject.pendingqty = 0;

                if (data) {
                    productionObject.quantity = data.prodPendingQty;
                    productionObject.pentQty = data.prodPendingQty;
                    productionObject.pendingqty = data.prodPendingQty;
                }
                this.setState({ productionObject: productionObject, pendingRowData: response.responseItem.responseContent });
            }
        }
    };


    btnAddBom_Click = () => {
        if (this.state.productionObject.idProduct > 0) {
            if (this.state.productionObject.prodQty > 0) {
                if (this.state.productionObject.idType === 2) { //"Through W.O.") {
                    this.usp_Master_ProductReceipeSelectbyIdforMaterialProductionWO();
                } else if (this.state.productionObject.idType === 1) {
                    this.usp_Master_ProductReceipeSelectbyIdforMaterialProduction();
                }
            } else {
                this.SwalServices.Error("Please enter Production Quantity.");
            }
        }
    };

    usp_Master_ProductReceipeSelectbyIdforMaterialProduction = () => {
        this.transactionStockServices.usp_Master_ProductReceipeSelectbyIdforMaterialProduction(this.state.productionObject.idProduct).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                let modifiedData = data.map((x, index) => {
                    return {
                        ...x,
                        keyId: index + 1,
                        itemDetails: x.itemName,
                        bom: x.quantity,
                        quantity: x.quantity * Number(this.state.productionObject.prodQty)
                    };
                });
                this.setState({ itemRowData: modifiedData });
            }
        });
    };

    usp_Master_ProductReceipeSelectbyIdforMaterialProductionWO = async () => {

        const response = await this.transactionStockServices
            .usp_Master_ProductReceipeSelectbyIdforMaterialProductionWO(this.state.productionObject.idProduct);

        if (response.statusCode === 200 && response.responseItem) {
            let data = response.responseItem.responseContent;
            let modifiedData = data.map((x, index) => {
                return {
                    ...x,
                    keyId: index + 1,
                    itemDetails: x.itemName,
                    bom: x.quantity,
                    quantity: x.quantity * Number(this.state.productionObject.prodQty)
                };
            });
            this.setState({ itemRowData: modifiedData });
        }
    };

    getItemMasterSelectbyID = () => {
        let request = this.state.itemObject.idItem;
        this.masterEntryServices.getItemMasterSelectbyID(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let allData = response.responseItem.responseContent[0];
                let data = this.state.itemObject;
                data.drawingNo = allData.drawingNo;
                data.itemType = allData.itemType;
                data.idItemType = allData.itemType ? data.itemTypeList.find(x => x.label === allData.itemType)?.value : data.idItemType;
                data.weight = allData.weight;
                this.setState({
                    itemObject: data
                }, () => {
                    //this.getTaxStructureSelectbyID();
                });
            }
        });
    }

    handleCellClickItemList = (event) => {
        let itemObject = this.state.itemRowData[event.data.keyId - 1];
        let data = this.state.itemObject;
        data.keyId = itemObject.keyId || 0;
        data.drawingNo = itemObject.drawingNo || "";
        data.itemType = itemObject.itemType || "";
        data.idItem = itemObject.idItem;
        data.itemDetails = itemObject.itemDetails;
        data.itemName = itemObject.itemDetails;
        data.quantity = Number(itemObject.quantity) || 0;
        data.weight = Number(itemObject.weight) || 0;
        data.itemRemarks = itemObject.itemRemarks || "";
        data.isNew = itemObject.isNew || 1;
        data.bom = itemObject.bom || 0;
        data.currentStock = itemObject.currentStock || 0;
        data.status = data.status || 0;
        data.tempId = data.tempId || Date.now()
        data.idItemType = data.itemTypeList?.find(x => x.label === itemObject.itemType)?.value || "";
        this.setState({ itemObject: data }, () => {
            this.getMaster_ItemSelectbyItemType(itemObject.itemType);
        });
    };

    insertItem = (flag) => {
        const { itemRowData, itemObject } = this.state;
        if (itemObject.idItem > 0 && itemObject.quantity && itemObject.quantity !== "") {
            let list = [...itemRowData];
            if (flag === 'Insert') {
                const exists = list.some(x => x.idItem === itemObject.idItem);
                if (!exists) {
                    const newRow = {
                        drawingNo: itemObject.drawingNo || "",
                        itemType: itemObject.itemType || "",
                        idItem: itemObject.idItem,
                        itemDetails: itemObject.itemName,
                        itemName: itemObject.itemName,
                        quantity: Number(itemObject.quantity) || 0,
                        weight: Number(itemObject.weight) || 0,
                        itemRemarks: itemObject.itemRemarks || "",
                        isNew: 1,
                        bom: itemObject.bom || 0,
                        currentStock: itemObject.currentStock || 0,
                        status: 0,
                        tempId: Date.now() // unique key for React
                    };

                    list.push(newRow);

                    list.map((item, index) => {
                        item.keyId = index + 1;
                        return item;
                    });
                    this.setState({
                        itemRowData: list
                    }, () => {
                        this.resetProductObject(); // reset all input fields
                    });
                }
            } else {
                // UPDATE MODE
                const index = list.findIndex(x => x.keyId === itemObject.keyId);
                if (index !== -1) {
                    list[index] = {
                        ...list[index],
                        drawingNo: itemObject.drawingNo || "",
                        itemType: itemObject.itemTypeList?.find(x => x.value === itemObject.idItemType)?.label || "",
                        idItem: itemObject.idItem,
                        itemDetails: itemObject.itemName,
                        itemName: itemObject.itemName,
                        quantity: Number(itemObject.quantity) || 0,
                        weight: Number(itemObject.weight) || 0,
                        itemRemarks: itemObject.itemRemarks || "",
                        bom: itemObject.bom || 0,
                        currentStock: itemObject.currentStock || 0,
                        isNew: 1,
                        status: itemObject.status || 0,
                    };
                }

                list.map((item, index) => {
                    item.keyId = index + 1;
                    return item;
                });

                this.setState({
                    itemRowData: list,
                }, () => {
                    this.resetProductObject();
                });
            }
        } else {
            this.SwalServices.Error("Please enter valid data.");
        }
    };

    resetProductObject = () => {
        this.setState({
            itemObject: {
                keyId: 0,
                drawingNo: '',
                itemTypeList: [
                    { value: 1, label: 'RAW MATERIAL' },
                    { value: 2, label: 'FINISHED GOODS' },
                    { value: 3, label: 'SEMI FINISHED' },
                    { value: 4, label: 'SCRAP MATERIAL' },
                ],
                idItemType: 2,
                itemType: '',
                itemList: [],
                idItem: 0,
                itemName: '',
                quantity: '',
                weight: '',
                itemRemarks: '',
                bom: 0,
                currentStock: 0,
                status: 0,
            },
            //formStatus: 0,
            //idItemEdit: null
        }, () => {
            this.getMaster_ItemSelectbyItemType('FINISHED GOODS');
        });
    };

    deleteItem = (keyId) => {
        //let data = this.state.itemObject;
        //let idTransferLocationDetails = this.state.itemRowData?.find(item => item.keyId == keyId)?.idTransferLocationDetails;
        let filterData = this.state.itemRowData?.filter(item => item.keyId !== keyId);
        if (filterData.length > 0) {
            filterData.map((x, key) => {
                x.keyId = key + 1;
            });
        }
        this.setState({ itemRowData: filterData }, () => {
            this.resetProductObject();
        });
    }

    submit = () => {
        if (this.isSubmitting) {
            return;
        }

        var Quantity1 = Number(this.state.productionObject.quantity ? this.state.productionObject.quantity : 0);
        var ProductionQty1 = Number(this.state.productionObject.prodQty ? this.state.productionObject.prodQty : 0);
        var PendingQty = Number(this.state.productionObject.pentQty ? this.state.productionObject.pentQty : 0);

        if (Quantity1 !== PendingQty) {
            if (ProductionQty1 <= Quantity1) {
                if (this.state.itemRowData.length === 0) {
                    this.SwalServices.Error("Please add item details.");
                    return;
                }
                let insufficientStockItems = this.state.itemRowData.filter(
                    item => Number(item.quantity) > Number(item.currentStock)
                );
                if (insufficientStockItems.length > 0) {
                    let itemNames = insufficientStockItems
                        .map(item => item.itemDetails || item.itemName || item.drawingNo)
                        .join(", ");
                    this.SwalServices.Error(
                        `Quantity cannot be greater than current stock for: ${itemNames}`
                    );
                    return;
                }
                if (this.state.productionObject.idNumber > 0 && this.state.productionObject.idProduct > 0) {
                    let details = this.state.productionObject;
                    var idWorkOrder = 0;
                    var idWorkPlanning = 0;
                    if (details.idType === 2) {
                        idWorkOrder = details.idNumber;
                        idWorkPlanning = 0;
                        //idwoOrderRecv
                    } else {
                        idWorkOrder = 0;
                        idWorkPlanning = details.idNumber;
                    }
                    let requestData = {
                        idMaterialProduction: details.idMaterialProduction,
                        productionNo: details.productionNo,
                        productionDate: details.date,
                        authEmployee: details.idAuthEmp,
                        idPlant: details.idPlant,
                        productionFrom: details.typeList.find(x => x.value === details.idType)?.label || '',

                        idWorkOrder: idWorkOrder,
                        idWorkPlanning: idWorkPlanning,
                        idItem: details.idProduct,
                        quantity: details.quantity,
                        productionQuantity: details.prodQty,
                        pendingQuantity: details.pentQty,
                        e_Date: details.e_Date ? details.e_Date : new Date().toISOString(),
                        e_IDUser: this.state.idUser,
                        isUpdated: details.updateStatus > 0 ? true : false,
                        updatedDate: details.updateStatus > 0 ? new Date().toISOString() : null,
                        u_IDUser: details.updateStatus > 0 ? this.state.idUser : 0,
                        isDeleted: false,
                        deletedDate: null,
                        d_IDUser: 0,
                        idCompany: this.state.idCompany,
                        prefix: details.prefix,
                        dbQty: details.dbQty,
                        idFinancialYear: null,
                        itemList: [],
                    };
                    requestData.itemList = this.state.itemRowData;

                    this.isSubmitting = true;
                    this.setState({ isSaving: true });
                    this.transactionStockServices.usp_Transaction_MaterialProductionInsetUpdate(requestData)
                        .then((response) => {
                            if (response.statusCode === 200 && response.responseItem !== null) {
                                let dynamicData = response.responseItem.responseContent;
                                if (dynamicData?.errorType === "Exists") {
                                    this.SwalServices.Warning(dynamicData.errorMessage);
                                } else {
                                    if (details.updateStatus === 1) {
                                        this.SwalServices.Success("Updated successfully.");
                                        this.setState({ isModalOpen: false })
                                    } else {
                                        this.SwalServices.Success("Saved successfully.");
                                    }

                                    this.resetDetailsFields();
                                    // this.setState({ isModalOpen: false }, () => {
                                    this.procSelectAllRecordsSP();
                                    // });
                                }
                            } else {
                                // this.setState({ isModalOpen: false }, () => {
                                this.SwalServices.Error(response.message);
                                this.procSelectAllRecordsSP();
                                // });
                            }
                        })
                        .catch((err) => {
                            this.SwalServices.Error("Something went wrong: " + err.message);
                        })
                        .finally(() => {
                            this.isSubmitting = false;
                            this.setState({ isSaving: false });
                        });
                } else {
                    this.SwalServices.Error("Please select valid Work Order/Planning and Product.");
                }
            }
        } else {
            this.SwalServices.Error("Plase Enter Correct Value.");
        }
    };

    usp_Transaction_MaterialProductionSelectbyId = async (id) => {
        const response = await this.transactionStockServices
            .usp_Transaction_MaterialProductionSelectbyId(id, this.state.idCompany);
        if (response.statusCode === 200 && response.responseItem) {
            let data = response.responseItem.responseContent[0][0];
            let itemList = response.responseItem.responseContent[1];
            let productionObject = this.state.productionObject;
            let itemRowData = [];
            if (data) {
                productionObject.idMaterialProduction = data.idMaterialProduction;
                productionObject.productionNo = data.productionNo;
                productionObject.date = data.productionDate ? moment(data.productionDate).format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD');
                productionObject.idAuthEmp = data.authEmployee;
                productionObject.idPlant = data.idPlant;
                productionObject.idType = data.productionFrom === 'Through W.O.' ? 2 : 1;
                productionObject.idNumber = data.productionFrom === 'Through W.O.' ? data.idWorkOrder : data.idWorkPlanning;
                productionObject.woRecvNo = data.productionFrom === 'Through W.O.' ?
                    productionObject.numberList.find(x => x.idWorkPlanning === data.idWorkOrder)?.workOrderNo :
                    productionObject.numberList.find(x => x.idWorkPlanning === data.idWorkPlanning)?.workOrderNo
                productionObject.idProduct = data.idWorkPlanningItems;
                productionObject.productName = data.productName;
                productionObject.quantity = data.quantity;
                productionObject.prodQty = data.productionQuantity;
                productionObject.pentQty = data.pendingQuantity;
                productionObject.pendingqty = data.pendingQuantity;
                productionObject.updateStatus = 1;
                productionObject.dbQty = data.productionQuantity;
                productionObject.e_Date = data.e_Date;

                productionObject.typeList = [
                    { value: 1, label: 'Through Planning' },
                    { value: 2, label: 'Through W.O.' },
                ];
                this.setState({ productionObject: productionObject, globalUserID: data.modifiedBy }, () => {
                    this.cmbFrom_SelectedIndexChanged();
                    this.cmbWO_EditValueChanged();
                    //this.cmbProduct_EditValueChanged();
                });

                if (itemList && itemList.length > 0) {
                    itemRowData = itemList.map((item, keyId) => ({
                        keyId: keyId + 1,
                        drawingNo: item.drawingNo || "",
                        itemType: item.itemType || "",
                        idItemType: this.state.itemObject.itemTypeList?.find(x => x.label === item.itemType)?.value || "",
                        idItem: item.idItem,
                        itemDetails: item.itemName || "",
                        quantity: item.quantity || 0,
                        weight: item.weight || 0,
                        itemRemarks: item.itemRemarks || "",
                        isNew: 0,
                        bom: item.bom || 0,
                        currentStock: item.currentStock || 0,
                        status: item.status ? item.status : 0,
                        tempId: Date.now() + Math.random() // unique key for React
                    }));
                }
                this.setState({ itemRowData: itemRowData });
            }
        }
    };

    setOpenModel2 = () => {
        this.setState({ isSelectItemPopUp: !this.state.isSelectItemPopUp });
    };

    setOpenModel3 = () => {
        this.setState({ isSelectNumberPopUp: !this.state.isSelectNumberPopUp });
    };

    setOpenModel5 = () => {
        this.setState({ isSelectNumberPopUpForThroughtWO: !this.state.isSelectNumberPopUpForThroughtWO });
    };

    setOpenModel4 = () => {
        this.setState({ isSelectItemObjectItemPopUp: !this.state.isSelectItemObjectItemPopUp });
    };

    handleDropdownCellClick = (event) => {
        let data = this.state.productionObject;
        data.idProduct = this.state.productionObject.idType === 2 ? event.data.idwoOrderRecvItems : event.data.idWorkPlanningItems;
        data.productName = event.data.itemName;
        data.originalPentQty = null
        this.setState({ productionObject: data, isSelectItemPopUp: !this.state.isSelectItemPopUp }, () => {
            this.cmbProduct_EditValueChanged()
        });
    };

    handleDropdownCellClickForNumber = (event) => {
        let data = this.state.productionObject;
        data.idNumber = event.data.idWorkPlanning;
        data.woRecvNo = event.data.workOrderNo;
        this.setState({ productionObject: data, isSelectNumberPopUp: !this.state.isSelectNumberPopUp }, () => {
            this.cmbWO_EditValueChanged();
        });
    };

    handleDropdownCellClickForNumberThroughtWO = (event) => {
        let data = this.state.productionObject;
        data.idNumber = event.data.idwoOrderRecv;
        data.woRecvNo = event.data.woRecvNo;
        this.setState({ productionObject: data, isSelectNumberPopUpForThroughtWO: !this.state.isSelectNumberPopUpForThroughtWO }, () => {
            this.cmbWO_EditValueChanged();
        });
    };

    handleDropdownCellClickForItem = (event) => {
        let data = this.state.itemObject;
        data.idItem = event.data.idItem;
        data.itemName = event.data.itemName;
        this.setState({ itemObject: data, isSelectItemObjectItemPopUp: !this.state.isSelectItemObjectItemPopUp }, () => {
            this.getItemMasterSelectbyID()
        });
    };

    handleOnClick = (event, name) => {
        if (name === 'productList') {
            this.setOpenModel2();
        }
        if (name === 'numberList') {
            if (this.state.productionObject.idType === 2) {
                this.setOpenModel5();
            } else {
                this.setOpenModel3();
            }
        }
        if (name === 'itemList') {
            this.setOpenModel4();
        }
    }

    handleCellClickForSecondTable = (event) => {
        let data = this.state.productionObject;
        data.idSalesInvoice = event.data.idMaterialProduction;
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({ productionObject: data, validState: validState }, () => {
            this.procSelectAllRecord2GridviewSP(event.data.idMaterialProduction, "Material Production");
        })
    };

    addPendingData = async () => {
        if (this.state.productionObject.idProduct > 0) {
            const response = await this.transactionStockServices
                .usp_Transaction_WorkPlanningSelect_Pending_WithNewChanges(this.state.productionObject.idProduct);
            if (response.statusCode === 200 && response.responseItem) {
                let data = response.responseItem.responseContent;
                let list = [];
                if (data.length > 0) {
                    list = data;
                    this.setState({ pendingRowData: list, isPendingOpen: true });
                } else {
                    this.SwalServices.Alert("No Data Found");
                    this.setState({ isPendingOpen: false, pendingRowData: [] }, () => {
                    });
                }
            }
        }
        else {
            this.SwalServices.Alert("Select product first");
            this.setState({ isPendingOpen: false, pendingRowData: [] });
        }
    };

    render() {
        return (
            <div className='store-to-plant'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ButtonGrp buttons={['add', 'print']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: () => this.openPopUpForUpdateItem(),
                                print: this.handlePrint,
                            }}
                        />
                        <MaterialProductionPopup
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            productionObject={this.state.productionObject}
                            itemObject={this.state.itemObject}
                            handleChange={this.handleChange.bind(this)}
                            close={this.closePopup.bind(this)}
                            submit={this.submit.bind(this)}
                            isSaving={this.state.isSaving}
                            validState={this.state.validState}
                            itemRowData={this.state.itemRowData}
                            handleChangeForDropdown={this.handleChangeForDropdown.bind(this)}
                            // addWorkOrder={this.addWorkOrder.bind(this)}
                            // addProduct={this.addProduct.bind(this)}
                            back={this.back.bind(this)}
                            open={this.state.open}
                            isPendingOpen={this.state.isPendingOpen}
                            setPendingModel={this.setPendingModel.bind(this)}
                            insertItem={this.insertItem.bind(this)}
                            handleCellClickItemList={this.handleCellClickItemList.bind(this)}
                            btnAddBom_Click={this.btnAddBom_Click.bind(this)}
                            handleOnClick={this.handleOnClick.bind(this)}
                            idUser={this.state.idUser}
                            usp_Users={this.state.usp_Users}
                            globalUserID={this.state.globalUserID}
                        //addPendingData={this.addPendingData.bind(this)}
                        // firstList={this.state.firstList}
                        // secondList={this.state.secondList}
                        // handleCellClickfirstList={this.handleCellClickfirstList.bind(this)}
                        // onSelectionChanged={this.onSelectionChanged.bind(this)}
                        />
                        <PendingWoData
                            isPendingOpen={this.state.isPendingOpen}
                            setPendingModel={this.setPendingModel.bind(this)}
                            pendingRowData={this.state.pendingRowData}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 300px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Material Production</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onCellClicked={this.handleCellClickForSecondTable}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>

                        <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.table2Data}
                                    columnDefs={this.state.table2ColDefs}
                                    rowHeight={this.state.rowHeight}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onGridReady={this.onGridReady}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <SelectItemListPopUp
                    modalName={"Select Item"}
                    selectItemList={this.state.productionObject.productList}
                    colDefs={this.state.selectItemColDefs}
                    isModalOpen={this.state.isSelectItemPopUp}
                    setOpenModel={this.setOpenModel2.bind(this)}
                    handleSelectChange={this.handleDropdownCellClick}
                />
                <SelectItemListPopUp
                    modalName={"Select Number"}
                    selectItemList={this.state.productionObject.numberList}
                    colDefs={this.state.selectNumberColDefs}
                    isModalOpen={this.state.isSelectNumberPopUp}
                    setOpenModel={this.setOpenModel3.bind(this)}
                    handleSelectChange={this.handleDropdownCellClickForNumber}
                />
                <SelectItemListPopUp
                    modalName={"Select Number For Through WO"}
                    selectItemList={this.state.productionObject.numberList}
                    colDefs={this.state.selectNumberColDefsForThroughWO}
                    isModalOpen={this.state.isSelectNumberPopUpForThroughtWO}
                    setOpenModel={this.setOpenModel5.bind(this)}
                    handleSelectChange={this.handleDropdownCellClickForNumberThroughtWO}
                />
                <SelectItemListPopUp
                    modalName={"Select Item For Item"}
                    selectItemList={this.state.itemObject.itemList}
                    colDefs={this.state.selectItemColDefsForITems}
                    isModalOpen={this.state.isSelectItemObjectItemPopUp}
                    setOpenModel={this.setOpenModel4.bind(this)}
                    handleSelectChange={this.handleDropdownCellClickForItem}
                />
            </div>
        )
    }
}
